import e from "./index27.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/merge/merge.js
function t(t, n) {
	return n ? e(t, n, { clone: !1 }) : t;
}
//#endregion
export { t as default };

//# sourceMappingURL=index32.js.map